import React, { useState } from "react";

export default function SmartDealPage() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);

  const fakeSearch = () => {
    setResults([
      {
        id: 1,
        name: "HG RX-78-2 Gundam",
        price: 999,
        shop_name: "Thai Gundam Shop",
        type: "Shopee Mall",
        link: "https://s.shopee.co.th/7zz3LvvBET",
        image: "",
      },
    ]);
  };

  return (
    <div className="p-4 max-w-screen-md mx-auto">
      <h1 className="text-2xl font-bold mb-4 text-center">SmartDeal-DAD</h1>

      <div className="mb-6">
        <input
          type="text"
          placeholder="ค้นหาสินค้า เช่น กันพลา..."
          className="w-full p-3 rounded-xl border shadow"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button
          className="mt-3 w-full bg-black text-white py-2 rounded-xl"
          onClick={fakeSearch}
        >
          ค้นหาเลย
        </button>
      </div>

      <div className="grid gap-4">
        {results.map((item) => (
          <div
            key={item.id}
            className="p-4 border rounded-2xl shadow-sm hover:shadow-md transition"
          >
            <div className="flex gap-4">
              <div className="w-24 h-24 bg-gray-200 rounded-xl"></div>
              <div className="flex-1">
                <h2 className="font-semibold text-lg">{item.name}</h2>
                <p className="text-sm text-gray-600 mb-1">
                  จากร้าน: {item.shop_name}
                </p>
                <p className="text-sm text-gray-500 mb-2">
                  ประเภท: {item.type}
                </p>
                <p className="text-xl font-bold text-green-600 mb-2">
                  ฿{item.price}
                </p>
                <a
                  href={item.link}
                  className="inline-block bg-orange-500 text-white px-4 py-2 rounded-xl text-sm"
                  target="_blank"
                  rel="noreferrer"
                >
                  ซื้อเลย
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
